/**
 * Тексты тултипов для сумм заказов в таблице клиентов админки.
 * Поясняют, почему цифры приблизительные.
 */
export const UNCONFIRMED_ORDERS_SUM_TOOLTIP =
  'Сумма всех заказов клиента без фильтра по оплате и завершению. Может включать отменённые, незавершённые и тестовые заказы; статусы оплаты часто выставляются вручную; возможны расхождения с Frontpad и платёжными системами.'

export const CONFIRMED_ORDERS_SUM_TOOLTIP =
  'Сумма заказов со статусом «Выполнен» или с оплатой «Оплачен» / «Оплачено» / «Наличные» / «Перевод», без «Отменён» и «Списан». Один заказ не суммируется дважды. Погрешность возможна из‑за ручных и нестандартных формулировок статусов оплаты.'
